import './create-user.scss'

import { notification } from 'antd'
import axios from 'axios'
import { Formik, FormikHelpers } from 'formik'
import { Form, FormItem, Input, SubmitButton } from 'formik-antd'
import { useState } from 'react'
import { Column } from 'react-display-flex'

import { parseApiErrorResponse } from '../../../components/forms/utils'
import { messages } from '../messages'
import { User } from '../models'
import { createUserInitialValues } from './initial-values'
import { CreateUserFormValues } from './model'

export const CreateUser = ({ onSuccess }: { onSuccess: (user: User) => void }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const onCreateUser = async (
    userFormValues: CreateUserFormValues,
    { setErrors }: FormikHelpers<CreateUserFormValues>,
  ) => {
    setIsSubmitting(true)

    try {
      const [login] = userFormValues.email.split('@')
      const { data: createdUser } = await axios.post<User>(`/users`, {
        ...userFormValues,
        password: `${login}@YOU_SHOULD_CHANGE_THIS_PASSWORD_AT_YOUR_TENANT`,
      })

      notification.success({ message: messages.common.success, description: messages.create.success })
      onSuccess(createdUser)
    } catch (error) {
      setErrors(parseApiErrorResponse(error))

      notification.error({ message: messages.common.error, description: messages.create.error })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Formik initialValues={createUserInitialValues} onSubmit={onCreateUser} enableReinitialize>
      <Form name="create-user">
        <FormItem name="firstName" label="Name" required>
          <Input name="firstName" placeholder="Name" />
        </FormItem>
        <FormItem name="surname" label="Surname" required>
          <Input name="surname" placeholder="Surname" />
        </FormItem>
        <FormItem name="email" label="Email" required>
          <Input name="email" placeholder="Email" />
        </FormItem>
        <p>
          The user must be instructed to click at the <b>Forgot your password?</b> link at the tenant page in order to
          create a password
        </p>
        <Column>
          <SubmitButton htmlType="submit" type="primary" loading={isSubmitting} disabled={isSubmitting}>
            Create User
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
